import { createApp } from 'vue'
import App from './App.vue'
import router from './roteador/indexRoteador'
import store from './store/store';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/style.css'
import '@/assets/img/logo.png'

createApp(App)
    .use(router)
    .use(store)
    .mount('#app')